
export default function formatNumber(number, fractionDigits) {
	if (isNaN(number)) return ""
	return new Intl.NumberFormat(undefined, { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(number)
}